module.exports = __webpack_public_path__ + "static/media/depoimento-curso-sushi-1.69face4b.png";